import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { TableCell, TableRow } from '@mui/material';

import { loadForm, searchFormParticipant } from '../../store/participantService';
import { reverseFormatDate } from '../../utils/dateFunctions';

import classes from '../../commonStyles/tables.module.css';

const FormTableRow = ({ row, onEdit }) => {
    // HOOKS
    const dispatch = useDispatch();

    // EVENT HANDLERS
    const onEditRow = () => {
        dispatch(loadForm(row.id));
        onEdit(row.id);
        dispatch(searchFormParticipant({ formId: row.id }));
    };

    // RENDER
    return (
        <TableRow
            hover
            className={`${classes.basicRowStripes} ${classes.canOpen}`}
            onClick={onEditRow}>
            <TableCell>{row.code}</TableCell>
            <TableCell>{row.name}</TableCell>
            <TableCell>{reverseFormatDate(row.dateCreated)}</TableCell>
            <TableCell>{row.inactive ? 'Inactive' : 'Active'}</TableCell>
        </TableRow>
    );
};

FormTableRow.propTypes = {
    row: PropTypes.object,
    onEdit: PropTypes.func
};

export default FormTableRow;
